import React, { Component } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import Axios from "../../redux/axiosHandlerGeo";
import { GeoJSON, MapContainer, TileLayer } from "react-leaflet";
import GeoJsonLayer from "./GeoJsonLayer";
import { infastructure, gaupalika, ward } from "../data/global";
import { totalWard } from "../data/config";
import { connect } from "react-redux";
import { selectedLanguage } from "../data/institute";

class MapSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            boundData: [],
            location: {
                lat: 28.0639113,
                lng: 82.7200879,
            },
            zoom: 11,
            checkbox: {
                economic: false,
            },
            wholeGeoJSON: {},
            showGeoJSON: [],
            wardCheckAll: false,
            indeterminateWard: false,
            // wardSelected: [],
            wardSelected: [...Array(totalWard).keys()].map((each) => each + 1),
        };
        this.getMunicpalId = this.getMunicpalId.bind(this);
    }

    componentDidMount() {
        this.arrangeAllOption();
    }

    isGeoJsonAlreadyFetched = (field) => {
        const { wholeGeoJSON } = this.state;
        return Boolean(field in wholeGeoJSON);
    };

    fetchGeoJSON = (changedData) => {
        const body = {
            ward: "fetch/ward",
            house: "house",
            // private: "institute/private",
            // community: "institute/community",
            // madrasa: "institute/madrasa",
            montessori: "institute/montessori",
            primary: "institute/primary",
            secondary: "institute/secondary",
            // gumba: "institute/gumba",
            college_nontechnical: "institute/college_nontechnical",
            college_technical: "institute/college_technical",
            university: "institute/university",
            skill_center: "institute/skill_center",
            hospital: "institute/hospital",
            healthPost: "institute/healthPost",
            urban_helath_center: "institute/urban_helath_center",
            basic_health_center: "institute/basic_health_center",
            village_clinic: "institute/village_clinic",
            // helpdesk: "institute/helpdesk",
            // maternity: "institute/maternity",
            clinic: "institute/clinic",
            ayurved: "institute/ayurved",
            bridge: "institute/bridge",
            stadium: "institute/stadium",
            // powerhouse: "institute/powerhouse",
            // powerstation: "institute/powerstation",
            community_building: "institute/community_building",
            // airport: "institute/airport",
            fm_station: "institute/fm_station",
            // tv_station: "institute/tv_station",
            tower: "institute/tower",
            calvert: "institute/calvert",
            water_tank: "institute/water_tank",
            // sabhaa_hal: "institute/sabhaa_hal",
            internet_provider: "institute/internet_provider",
            a: "institute/a",
            b: "institute/b",
            c: "institute/c",
            public_toilet: "institute/public_toilet",
            free_wifi: "institute/free_wifi",
            buspark: "institute/buspark",
            park: "institute/park",
            zoo: "institute/zoo",
            land_revenue: "institute/land_revenue",
            dao: "institute/dao",
            court: "institute/court",
            ministries: "institute/ministries",
            electricity: "institute/electricity",
            dcc: "institute/dcc",
            ngo: "institute/ngo",
            ingo: "institute/ingo",
            brick_industry: "institute/brick_industry",
            sugar_mill: "institute/sugar_mill",
            mill: "institute/mill",
            police: "institute/police",
            apf: "institute/apf",
            army: "institute/army",
            traffic: "institute/traffic",
            mining: "institute/mining",
            waterfall: "institute/waterfall",
            cave: "institute/cave",
            lake: "institute/lake",
            pond: "institute/pond",
            main_water_source: "institute/main_water_source",
            temple: "institute/temple",
            mosque: "institute/mosque",
            // gumba: "institute/gumba",
            museum: "institute/museum",
            palace: "institute/palace",
            cultural_club: "institute/cultural_club",
            forest: "institute/forest",
            palika_related_office: "institute/palika_related_office",
        };

        return new Promise((resolve, reject) => {
            Axios.get(`/api/geojson/${body[changedData]}`)
                .then((result) => {
                    let wholeGeoJSON = this.state.wholeGeoJSON;
                    this.setState(
                        {
                            wholeGeoJSON: {
                                ...wholeGeoJSON,
                                [changedData]: result.data,
                            },
                        },
                        this.arrangeAllOption
                    );
                })
                .catch((err) => reject());
        });
    };

    arrangeAllOption = async () => {
        const { checkbox, wardSelected, wardCheckAll } = this.state;
        const showGeoJSON = [];
        console.log("Wholegeojson", this.state.wholeGeoJSON);
        if (!this.isGeoJsonAlreadyFetched("ward"))
            await this.fetchGeoJSON("ward");
        showGeoJSON.push(
            wardSelected.map((each) => this.state.wholeGeoJSON.ward[each - 1])
        );

        let dataToCheck = [];

        dataToCheck = dataToCheck.concat(infastructure);
        console.log("dataToCheck", dataToCheck);
        console.log("Checkbox", checkbox);
        const data = dataToCheck.map(async (each, i) => {
            if (each.children) {
                each.children.map(async (child) => {
                    if (checkbox[child.value]) {
                        console.log("childValue", child.value);
                        if (!this.isGeoJsonAlreadyFetched(child.value))
                            await this.fetchGeoJSON(child.value);
                        if (wardCheckAll)
                            showGeoJSON.push(
                                this.state.wholeGeoJSON[child.value]
                            );
                        else
                            wardSelected.map((eachWard) => {
                                showGeoJSON.push(
                                    Object.values(
                                        this.state.wholeGeoJSON[child.value]
                                    ).filter(
                                        (eachType) =>
                                            eachType.wardNo === eachWard
                                    )
                                );
                            });
                        console.log("ShowGeojson", showGeoJSON);
                    }
                });
                console.log("WholeGeojson", this.state.wholeGeoJSON);
            } else {
                if (checkbox[each.value]) {
                    if (!this.isGeoJsonAlreadyFetched(each.value))
                        await this.fetchGeoJSON(each.value);

                    if (wardCheckAll)
                        showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
                    else
                        wardSelected.map((eachWard) => {
                            showGeoJSON.push(
                                this.state.wholeGeoJSON[each.value].filter(
                                    (eachType) => eachType.wardNo === eachWard
                                )
                            );
                        });
                }
            }
        });
        // wait until all promises resolve
        await Promise.all(data);
        this.setState({ showGeoJSON });
    };

    onCheckAllWardChange = (e) => {
        this.setState((prev) => {
            return {
                wardSelected: !prev.wardCheckAll
                    ? [...Array(totalWard).keys()].map((each) => each + 1)
                    : [],
                indeterminateWard: false,
                wardCheckAll: !prev.wardCheckAll,
            };
        }, this.arrangeAllOption);
    };

    handleWardChange = (e) => {
        const checkedValue = e.target.value;
        let wardSelected;
        let checkedValueInt = parseInt(checkedValue);
        if (this.state.wardSelected.includes(checkedValueInt)) {
            wardSelected = this.state.wardSelected
                .filter((i) => i !== checkedValueInt)
                .sort();
        } else {
            wardSelected = [...this.state.wardSelected, checkedValueInt].sort();
        }
        this.setState(
            {
                wardSelected,
                indeterminateWard:
                    !!checkedValue.length &&
                    checkedValue.length > 0 &&
                    checkedValue.length < totalWard,
                wardCheckAll: checkedValue.length === totalWard,
            },
            this.arrangeAllOption
        );
    };

    handleChange = (e) => {
        // console.log("handleChange", e.target);
        e.persist();
        this.setState(
            ({ checkbox }) => ({
                checkbox: {
                    ...checkbox,
                    [e.target.name]: e.target.checked,
                },
            }),
            this.arrangeAllOption
        );
    };

    style(feature) {
        let skin = "blue";
        if (feature.properties.FIRST_GaPa === "Dhangadhi") {
            skin = "green";
        }
        return {
            fillColor: skin,
            weight: 1,
            opacity: 1,
            color: "black",
            fillOpacity: 0.3,
        };
    }

    getMunicpalId() {
        return (
            <div className="map-section">
                <MapContainer
                    style={{ height: "550px" }}
                    center={this.state.location}
                    zoom={this.state.zoom}
                    minZoom="11"
                >
                    <TileLayer
                        url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    />
                    {/* {this.state.showGeoJSON.length > 0 &&
						this.state.showGeoJSON.map((each) => {
							return (
								each.length > 0 &&
								Object.values(each).map((eachGeoJSON, index) => {
									if (eachGeoJSON)
										return ( */}
                    <GeoJsonLayer
                        showGeoJSON={this.state.showGeoJSON}
                        // type={eachGeoJSON.type}
                        // key={index}
                        // style={eachGeoJSON.style}
                        // data={eachGeoJSON.geoJson}
                        // houseClick={this.onHouseNumberClick}
                    />
                    {/* );
								})
							);
						})} */}
                </MapContainer>
            </div>
            // <div className="col-lg-12 pb-5 d-flex align-items-stretch">
            //     <Card>
            //         <Card.Body>

            //             {/* boundary map goes here */}
            //             {/* <p className="mun-id-desc">
            //                 सुदूरपश्चिम प्रदेश (तत्कालिन सुदूरपश्चिमाञ्चल विकास क्षेत्रमा पर्ने महाकाली अञ्चल), कञ्चनपुर जिल्लाको सदरमुकामको रुपमा धनगढी नगरपालिका राजधानी काठमाडौंबाट ७५० कि.मी. को दुरीमा रहेको छ । कंचनपुर जील्लामा भएका ९ स्थानिय तहमा सात वटा नगरपालिका मध्ये सबैभन्दा जेठो नगरपालिका हो। तत्कालिन महेन्द्रनगर पञ्चायतको रुपमा वि.सं. २०३४ सालमा भूजेला,सिद्धनाथ र आदर्श गाँउ पञ्चायतका सम्पुर्ण भाग तथा सुडा र ऐरी गाँउ पञ्चायतको आंशिक भू-भाग मिलाई गठन भएको हो । महेन्द्रनगर नामाकरण गर्नुपुर्व यसको बजार क्षेत्रलाई धुसुडी बजार भनिन्थ्यो । वि.सं. २०४७ सालको जनआन्दोलन पश्चात महेन्द्रनगर नगरपञ्चायत बाट नाम परिवर्तन गरी महेन्द्रनगर नगरपालिका बनाइयो र वि.सं. २०६५ साल कार्तिक २० गतेको नेपाल सरकार मन्त्रि परिषदको निर्णयानुसार (शहिद धनगढी पन्तको सम्मानस्वरुप उहाँको नाममा) यस नगरपालिकालाई धनगढी नगरपालिका नामाकरण गरियो ।
            //             </p> */}
            //         </Card.Body>
            //     </Card>
            // </div>
        );
    }

    getDropdownIcon = (icon) => {
        return (
            <img
                className="mr-3"
                src={toAbsoluteUrl(`/media/hamropalika/png-icons/${icon}.png`)}
                alt=""
            />
            // <span className="icon-container mr-3" style={{ backgroundColor: "#FFF4DE" }}>
            //     <i className="icon-ic-borrowed-books" style={{
            //         color: '#FFA800',
            //     }}></i>
            // </span>
        );
    };

    getDropdownContent = () => {
        return infastructure.map((category) => {
            return (
                <>
                    <div className="d-flex justify-content-start mb-2">
                        {category.icon && this.getDropdownIcon(category.icon)}
                        {!category.value && (
                            <Dropdown className="mt-2 w-100">
                                <Dropdown.Toggle
                                    variant="outline-secondary"
                                    id="map-filter-dropdown"
                                    className="text-left"
                                    block
                                >
                                    {category[selectedLanguage]}
                                    {/* {this.props.selectedLanguage == "nepali"
										? category.nepali
										: category.english} */}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {category.children &&
                                        category.children.map((child) => (
                                            <Dropdown.Item
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={child.value}
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    e
                                                                )
                                                            }
                                                            checked={
                                                                this.state
                                                                    .checkbox[
                                                                    child.value
                                                                ]
                                                            }
                                                            value="checkedA"
                                                        />
                                                    }
                                                    label={
                                                        child[selectedLanguage]
                                                    }
                                                    // {
                                                    // 	this.props.selectedLanguage == "nepali"
                                                    // 		? child.nepali
                                                    // 		: child.english
                                                    // }
                                                />
                                            </Dropdown.Item>
                                        ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                        {category.value && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={category.value}
                                        onChange={(e) => this.handleChange(e)}
                                        checked={
                                            this.state.checkbox[category.value]
                                        }
                                        value="checkedA"
                                    />
                                }
                                label={category[selectedLanguage]}
                                // {
                                // 	this.props.selectedLanguage == "nepali"
                                // 		? category.nepali
                                // 		: category.english
                                // }
                            />
                            // <Dropdown className="mt-2 ">
                            //     <Dropdown.Toggle variant="outline-secondary" id="map-filter-dropdown">
                            //         {this.props.selectedLanguage == "nepali" ? category.nepali : category.english}
                            //     </Dropdown.Toggle>

                            //     <Dropdown.Menu>
                            //         {
                            //             category.children && category.children.map((child) => (
                            //                 <Dropdown.Item ></Dropdown.Item>
                            //             )
                            //             )
                            //         }
                            //     </Dropdown.Menu>
                            // </Dropdown>
                        )}
                    </div>
                </>
            );
        });
    };

    getWardDropDown = () => {
        return (
            <>
                <div className="d-flex justify-content-start ml-3">
                    {/* {this.getDropdownIcon("infrastructure")} */}

                    <Dropdown className="mt-2 w-100">
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            id="map-filter-dropdown"
                            className="text-left"
                            block
                        >
                            वडा
                            {/* {this.props.selectedLanguage == "nepali" ? "वडा" : "Ward"} */}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={(e) => e.stopPropagation()}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            indeterminate={
                                                this.state.indeterminateWard
                                            }
                                            onClick={(e) =>
                                                this.onCheckAllWardChange(e)
                                            }
                                            checked={this.state.wardCheckAll}
                                        ></Checkbox>
                                    }
                                    label={gaupalika[selectedLanguage]}
                                />
                            </Dropdown.Item>
                            {ward.map((each) => (
                                <Dropdown.Item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.wardSelected.includes(
                                                    parseInt(each.value)
                                                )}
                                                value={parseInt(each.value)}
                                                onClick={(e) =>
                                                    this.handleWardChange(e)
                                                }
                                            />
                                        }
                                        label={each[selectedLanguage]}
                                    />
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        );
    };

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <Card>
                        <Card.Body>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="d-flex align-items-center my-5">
                                        <SVG
                                            width="52"
                                            height="52"
                                            className="primary-icon"
                                            src={toAbsoluteUrl(
                                                "media/hamropalika/svg/area-with-pins.svg"
                                            )}
                                            alt=""
                                        />
                                        <h1 className="ml-3 mb-0">
                                            नक्शा
                                            {/* {this.props.selectedLanguage == "nepali"
												? "नक्शा"
												: "Map"} */}
                                        </h1>
                                    </div>
                                    {this.getMunicpalId()}
                                    {/* <a href={toAbsoluteUrl("/media/hamropalika/resource.zip")}>
										<button className="btn btn-light-primary mt-3 float-right">
											Download Resource Map
										</button>
									</a> */}
                                    {/* <div className="map-section">
                                        <MapContainer
                                            style={{ height: "50vh" }}
                                            center={this.state.location}
                                            zoom={this.state.zoom}
                                        >
                                            <TileLayer
                                                url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            />

                                            {this.state.showGeoJSON.length > 0 &&
                                                this.state.showGeoJSON.map((each) => {
                                                    return (
                                                        each.length > 0 &&
                                                        each.map((eachGeoJSON) => {
                                                            if (eachGeoJSON)
                                                                return (
                                                                    <GeoJsonLayer
                                                                        type={eachGeoJSON.type}
                                                                        key={eachGeoJSON.name}
                                                                        style={eachGeoJSON.style}
                                                                        data={eachGeoJSON.geoJson}
                                                                    />
                                                                );
                                                        })
                                                    );
                                                })}
                                            <GeoJSON
                                                key={hash(this.state.wholeGeojson)}
                                                data={this.state.wholeGeojson}
                                            />
                                        </MapContainer>
                                    </div> */}
                                </div>
                                <div className="col-md-3">
                                    <div className="d-flex align-items-center my-5">
                                        <SVG
                                            width="45"
                                            height="45"
                                            className="primary-icon"
                                            src={toAbsoluteUrl(
                                                "media/hamropalika/svg/filter.svg"
                                            )}
                                            alt=""
                                        />
                                        <h1 className="ml-3 mb-0">
                                            फिल्टर
                                            {/* {this.props.selectedLanguage == "nepali"
												? "फिल्टर"
												: "Filters"} */}
                                        </h1>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <div
                                                style={{
                                                    height: "605px",
                                                    overflowX: "auto",
                                                }}
                                            >
                                                {this.getWardDropDown()}
                                                {this.getDropdownContent()}
                                                {/* <FormControlLabel
													control={
														<Checkbox
															indeterminate={this.state.indeterminateWard}
															onChange={(e) => this.onCheckAllWardChange(e)}
															checked={this.state.wardCheckAll}
														></Checkbox>
													}
													label={gaupalika[this.props.selectedLanguage]}
												/>
												<FormGroup>
													{ward.map((each) => (
														<FormControlLabel
															control={
																<Checkbox
																	checked={this.state.wardSelected.includes(
																		parseInt(each.value)
																	)}
																	value={parseInt(each.value)}
																	onChange={(e) =>
																		this.handleWardChange(e.target.value)
																	}
																/>
															}
															label={each[this.props.selectedLanguage]}
														/>
													))}
												</FormGroup> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }
}
// const MapPage = () => {
//     return (
//         <>
//             <Card style={{ height: "76vh" }}>

//             </Card>
//         </>
//     );
// }
// const mapStateToProps = (state) => ({
// 	selectedLanguage: state.ward.selectedLanguage,
// });

export default MapSection;
// export default connect(mapStateToProps)(MapSection);
